import { useMemo } from 'react'
import { usePageControls } from './useCharts'

/** value_type -> nice label, from get_controls.kpi_values (label_definition item_label).
 *  Used to prettify multi-value_type chart-series legends for bare kpis (whose fact
 *  value_types are not in kpi_metadata). Reuses the cached usePageControls query. */
export function useValueTypeLabels(factTable: string): Record<string, string> {
  const controls = usePageControls(factTable)
  return useMemo(() => {
    const items = controls.data?.kpi_values?.items ?? []
    return Object.fromEntries(items.map((i) => [i.value, i.label]))
  }, [controls.data])
}
